module.exports = {"350623100":"绥安镇","350623101":"旧镇镇","350623102":"佛昙镇","350623103":"赤湖镇","350623104":"杜浔镇","350623105":"霞美镇","350623106":"官浔镇","350623107":"石榴镇","350623108":"盘陀镇","350623109":"长桥镇","350623110":"前亭镇","350623111":"马坪镇","350623112":"深土镇","350623113":"六鳌镇","350623114":"沙西镇","350623115":"古雷镇","350623116":"大南坂镇","350623200":"南浦乡","350623201":"赤岭畲族乡","350623202":"湖西畲族乡","350623203":"赤土乡","350623400":"漳浦盐场","350623401":"万安农场","350623402":"石古农场","350623403":"长桥农场","350623404":"白竹湖农场","350623405":"南山华侨茶果场","350623406":"中西林场","350623407":"玳瑁山茶场","350623408":"下蔡林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350623.json
// module id = 1115
// module chunks = 0